import { render, staticRenderFns } from "./WhatOurCustomerSays.vue?vue&type=template&id=bce6969e&"
import script from "./WhatOurCustomerSays.vue?vue&type=script&lang=js&"
export * from "./WhatOurCustomerSays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports